



































import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import QuestionCmpt from "../Question/QuestionCmpt.vue";
import Loader from "../Loader.vue";
import Result from "./Result";
import Time from "../Timer/Time";
import {ERRORS_TOTAL_LIMIT} from '../Question/Question';

@Component({
    components: {
        QuestionCmpt,
        Loader,
    }
})
export default class ResultCmpt extends Vue {
    @Prop({type: Object, required: true}) public result!: Result;

    public hint: boolean = false;
    public title: string = "";

    get time(): string {
        return (new Time(this.result.time).getHalf(new Time("20:00"))).toString();
    }

    get resultStatus(): string {
        return this.result.status ? "Сдано!" : "Не сдано!";
    }
    get resultClass(): string {
        return !this.result.status ? "red" : "green";
    }

    get reason(): string | null {
        if (this.result.questions.countAnswers === this.result.questions.length && this.result.questions.errorsCount > 2) {
            return `Вы допустили более ${ERRORS_TOTAL_LIMIT}-х ошибок`;
        } else if (this.result.questions.countAnswers !== this.result.questions.length) {
            return "Вы не уложились во время";
        } else {
            return null;
        }
    }
}
